import React, { Component } from 'react';
import { Container, Row, Col, Card, Badge, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { GoRepo } from 'react-icons/go';
import ExternalLink from 'components/controls/ExternalLink/index';
import BlobHeaderToggle from 'components/blob/BlobHeaderToggle/index';
import ReactGA from 'react-ga';
import Utils from 'context/utils';
import './index.css';

export default class BlobHeader extends Component {
  shouldShowDescriptionLine() {
    return (
      ( this.props.blob.description && this.props.blob.description.length > 0 ) ||
      ( this.props.blob.url && this.props.blob.url.length > 0 ) ||
      ( this.props.blob.tags && this.props.blob.tags.length > 0 )
    );
  }

  render() {
    const orgId = this.props.match.params.orgId;
    const scope = this.props.scope || {};

    return (
      <>
        <Container className="blob-header-row repo-name-row">
          <Row>
            <Col sm={6}>
              <h5>
                <GoRepo/>
                &nbsp;&nbsp;<Link to={`/${orgId}`}>{Utils.displayName(this.props.org, orgId)}</Link> /&nbsp;
                {/* blobId from the ROUTE PARAMS, not blob.alias — the same source the org half above
                    already uses. A link from a page to ITSELF must not change the URL's identity
                    form: a user who arrived by id and clicked the blob's own name used to be moved
                    from /org/<id> to /org/<alias>, which is a different param for the same blob.
                    That was harmless only while the page never remounted on a param change; now that
                    RouteWrapper keys on orgId/blobId it would tear down the whole shell and discard
                    unsaved workflow and playground edits, with no beforeunload guard anywhere in
                    src/ to warn. With the param, clicking the name is a same-URL no-op. */}
                <Link to={`/${orgId}/${this.props.match.params.blobId}`}>
                  {Utils.displayName(this.props.blob)}
                </Link>
              </h5>
            </Col>
            <Col sm={6} className="text-right">
              <BlobHeaderToggle scope={scope}/>
            </Col>
          </Row>
        </Container>
          {this.shouldShowDescriptionLine() &&
            <Container className="blob-header-row repo-description-row">
              <>
                {this.props.blob.description && this.props.blob.description.length > 0 &&
                  <>
                    {this.props.blob.description}&nbsp;
                  </>
                }
                {this.props.blob.url && this.props.blob.url.length > 0 &&
                  <>
                    <ExternalLink href={this.props.blob.url} text={this.props.blob.url}/>&nbsp;
                  </>
                }
                {this.props.blob.tags && this.props.blob.tags.length > 0 &&
                  <>
                    {this.props.blob.tags.map((tag, index) => {
                      return (
                        <>
                          <Badge variant="secondary" className="tag-badge">{tag}</Badge>
                          &nbsp;
                        </>
                      );
                    })}
                  </>
                }
              </>
            </Container>
          }
      </>
    );
  }
}
